import { render, staticRenderFns } from "./QuestionsPanel.vue?vue&type=template&id=5ae31bc7&scoped=true&"
import script from "./QuestionsPanel.vue?vue&type=script&lang=js&"
export * from "./QuestionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsPanel.vue?vue&type=style&index=0&id=5ae31bc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae31bc7",
  null
  
)

export default component.exports